import { QUERY_KEYS } from "@/libraries/constant";
import { getMemberQueryOptions } from "@/queries";
import { onlineManager } from "@tanstack/react-query";
import type { RouteContext } from "@tanstack/react-router";

export function getContactPeopleLoader(ctx: RouteContext, id: any) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureQueryData(getMemberQueryOptions(id));
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_MEMBER, id]);
}
